import { OptionResolver } from "./core/OptionResolver";
import { StateReducer } from "./core/StateReducer";
import { CookieManager } from "./core/CookieManager";
import { DOMBuilder } from "./core/DOMBuilder";
import { ActionType } from "./core/StateReducer.types";
var DarkModeToggle = /** @class */ (function () {
    function DarkModeToggle(element, opts) {
        if (opts === void 0) { opts = {}; }
        var _this = this;
        this.cookie = new CookieManager();
        this.element = element;
        this.options = OptionResolver.resolve(element, opts);
        this.state = new StateReducer(this.options.state);
        this.applyPreferredScheme();
        this.dom = new DOMBuilder(this.element, this.options);
        this.dom.onChange(function (e) {
            _this.toggle(true);
            _this.updateCookie();
            e.preventDefault();
        });
        this.element._bsDarkmodeToggle = this;
        this.update();
    }
    DarkModeToggle.prototype.update = function () {
        var isLight = this.state.get().isLight;
        this.dom.setState(isLight);
        this.updateCookie();
    };
    DarkModeToggle.prototype.toggle = function (silent) {
        if (silent === void 0) { silent = false; }
        if (!this.state.do(ActionType.TOGGLE))
            return;
        this.update();
        this.trigger(silent);
    };
    DarkModeToggle.prototype.light = function (silent) {
        if (silent === void 0) { silent = false; }
        if (!this.state.do(ActionType.LIGHT))
            return;
        this.update();
        this.trigger(silent);
    };
    DarkModeToggle.prototype.dark = function (silent) {
        if (silent === void 0) { silent = false; }
        if (!this.state.do(ActionType.DARK))
            return;
        this.update();
        this.trigger(silent);
    };
    DarkModeToggle.prototype.allowCookie = function () {
        this.options.allowCookie = true;
        this.updateCookie();
    };
    DarkModeToggle.prototype.denyCookie = function () {
        this.options.allowCookie = false;
        this.cookie.delete(DarkModeToggle.COOKIE_NAME);
    };
    DarkModeToggle.prototype.trigger = function (silent) {
        if (!silent) {
            this.element.dispatchEvent(new Event("change", { bubbles: true }));
        }
    };
    DarkModeToggle.prototype.updateCookie = function () {
        if (this.options.allowCookie) {
            this.cookie.set(DarkModeToggle.COOKIE_NAME, this.state.get().isLight
                ? this.options.lightColorMode
                : this.options.darkColorMode, 0.25);
        }
    };
    DarkModeToggle.prototype.applyPreferredScheme = function () {
        if (!this.options.allowCookie)
            return;
        var cookie = this.cookie.get(DarkModeToggle.COOKIE_NAME);
        if (cookie === this.options.darkColorMode)
            this.state.do(ActionType.DARK);
        if (cookie === this.options.lightColorMode)
            this.state.do(ActionType.LIGHT);
    };
    DarkModeToggle.COOKIE_NAME = "bs-darkmode-toggle-color-scheme";
    return DarkModeToggle;
}());
export { DarkModeToggle };
